<template>
  <v-card flat>
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div>
        <span class="d-block text--secondary">Ключ идемпотентности</span>
        <span class="d-block font-weight-medium">{{ idempotencyKey || 'не задан — заказ уходил в банк номером' }}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        small
        :loading="loading"
        @click="refresh()"
      >
        <v-icon
          size="18"
          class="me-2"
        >
          {{ icons.mdiRefresh }}
        </v-icon>
        <span>Обновить</span>
      </v-btn>
    </v-card-text>

    <v-card-text>
      <v-alert
        v-if="loaded && !receiverAvailable"
        text
        color="warning"
        class="mb-0"
      >
        Сервис приёма платежей не ответил. Колбэки банка живут в нём, поэтому сказать,
        что происходило с оплатой, сейчас нельзя.
      </v-alert>

      <v-alert
        v-else-if="loaded && !callbacks.length"
        text
        color="info"
        class="mb-0"
      >
        Банк по этому заказу не звонил: колбэков нет.
      </v-alert>

      <v-expansion-panels
        v-else-if="callbacks.length"
        accordion
        multiple
      >
        <payment-callback-panel
          v-for="callback in callbacks"
          :key="callback.id"
          :callback="callback"
        ></payment-callback-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mdiRefresh } from '@mdi/js'
import PaymentCallbackPanel from '@/views/payment/payment-callback-panel.vue'

export default {
  name: 'OrderPaymentLog',
  components: { PaymentCallbackPanel },
  async mounted() {
    await this.refresh()
  },
  data: () => ({
    icons: { mdiRefresh },
  }),
  computed: {
    ...mapState('orderPaymentLog', [
      'idempotencyKey',
      'receiverAvailable',
      'callbacks',
      'loading',
      'loaded',
    ]),
  },
  methods: {
    ...mapActions('orderPaymentLog', ['fetchLog']),
    async refresh() {
      const { id } = this.$route.params
      await this.fetchLog(id)
    },
  },
}
</script>
